import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { KeyValueEditor } from "@/components/itsm-config/key-value-editor";
import { useDraft } from "@/components/itsm-config/draft-context";

/**
 * Free-form config tags (top-level, sibling of provider_config), consumed by
 * well-known keys. Main use: `outbound_record_type.<harmony_type>` routes
 * outbound ticket creation to another record type.
 */
export function TagsSection() {
  const { tags, setTags } = useDraft();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Tags</CardTitle>
        <CardDescription>
          Key/value knobs consumed by well-known keys. Known:{" "}
          <span className="font-mono text-xs">
            outbound_record_type.&lt;harmony_type&gt;
          </span>{" "}
          routes outbound ticket creation to another record type (e.g.{" "}
          <span className="font-mono text-xs">
            outbound_record_type.request → incident
          </span>
          ).
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="max-w-2xl">
          <KeyValueEditor
            value={tags ?? {}}
            onChange={(next) => {
              setTags(Object.keys(next).length ? next : null);
            }}
            keyLabel="Tag key"
            valueLabel="Value"
            keyPlaceholder="outbound_record_type.request"
            valuePlaceholder="incident"
          />
        </div>
      </CardContent>
    </Card>
  );
}
